{
    "comment_slider.response": "contribution",
    "comment_slider.responses": "contributions",
    "editorial_question.lets_talk": "Suggest a solution",
    "editorial_question.share_thoughts": "Share your idea",
    "login.continue_with": "Log in with SBC",
    "question.input_placeholder": "Your idea:",
    "upvote.count": "{count} in favour"
}
